import { useEffect } from 'react';

import { useSkippableCoordination } from '@confluence/skippable-coordination-client';

import { useUserInfo } from '../../store/userInfoStore';
import { useExperimentInfoActions } from '../../store/experimentInfoStore';
import { COORDINATION, useHandleHookStates } from '../useHandleHookStates';

export const useLoadModalCoordinationToStore = () => {
	const { modalKey } = useUserInfo();
	const { setEpMessageReady, setStopEpMessage } = useExperimentInfoActions();
	const [startModalCoordination, stopModalCoordination, skippableCoordinationLoading] =
		useSkippableCoordination(modalKey || '', !modalKey);

	useHandleHookStates({
		loading: skippableCoordinationLoading,
		hook: COORDINATION,
	});

	useEffect(() => {
		if (modalKey !== undefined && !skippableCoordinationLoading) {
			void setEpMessageReady(startModalCoordination);
			void setStopEpMessage(stopModalCoordination);
		}
	}, [
		setEpMessageReady,
		startModalCoordination,
		modalKey,
		skippableCoordinationLoading,
		stopModalCoordination,
		setStopEpMessage,
	]);
};
